import { Component, OnInit } from '@angular/core';
import {
  config,
  Company,
  CompanyOfferModel,
  Survey,
  AnnouncementService,
  MemberQuery,
  MemberCard,
  MemberCardQuery,
} from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OwlCarouselSettings } from 'src/app/shared/utilities/owl-carousel-settings';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  screenType = ScreenType;
  polls$: Observable<Survey[]>;
  config = config;
  companies$: Observable<Company[]>;
  featuredOffers$: Observable<CompanyOfferModel[]>;
  name$: Observable<string>;
  card$: Observable<MemberCard | undefined>;

  customOptions: OwlOptions = {
    autoHeight: true,
    autoWidth: true,
    margin: OwlCarouselSettings.Margin,
    autoplay: OwlCarouselSettings.Autoplay,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: { items: 1 },
      740: { items: 2 },
      900: { items: 3 },
    },
  };

  constructor(
    private announcementService: AnnouncementService,
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery
  ) {}

  ngOnInit() {
    this.card$ = this.memberCardQuery.selectObservedMemberCard();
    this.name$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          return `${m.FirstName}`;
        }
        return '';
      })
    );

    this.announcementService.fetchAnnouncements().toPromise();
  }
}
